import * as Common from '@piccolohealth/pbs-common';
import { LabelType } from '@piccolohealth/pbs-common';
import type { RadioStackOption, SelectOption } from '@piccolohealth/ui';
import React from 'react';
import { FaRegFileAlt, FaRegStickyNote } from 'react-icons/fa';
import { FormStack } from '../../components/forms/FormStack';
import { HookedFormField } from '../../components/forms/HookedFormField';
import { HookedInput } from '../../components/forms/HookedInput';
import { HookedLabelChooser } from '../../components/forms/HookedLabelChooser';
import { HookedRadioStack } from '../../components/forms/HookedRadioStack';
import { HookedSelect } from '../../components/forms/HookedSelect';
import { templateStatusOptions } from './TemplateStatusTag';

const documentTypeOptions: RadioStackOption[] = [
  {
    label: 'Participant document',
    value: Common.TemplateType.ParticipantDocument,
    description: 'A template for a participant document.',
    icon: <FaRegFileAlt />,
  },
  {
    label: 'Participant note',
    value: Common.TemplateType.ParticipantNote,
    description: 'A template for a participant note.',
    icon: <FaRegStickyNote />,
  },
];

const statusOptions: SelectOption<Common.TemplateStatus>[] = [
  Common.TemplateStatus.Draft,
  Common.TemplateStatus.Published,
].map((status) => {
  const { color, label } = templateStatusOptions[status];

  return {
    label,
    color,
    value: status,
    raw: status,
  };
});

interface Props {
  isEditing?: boolean;
}

export const TemplateForm = (props: Props) => {
  const { isEditing } = props;

  return (
    <FormStack>
      <HookedFormField name='name' label='Name' helperText='The name of the template' required>
        <HookedInput name='name' size='sm' placeholder='Enter a name' />
      </HookedFormField>
      {!isEditing && (
        <HookedFormField name='type' label='Type' required>
          <HookedRadioStack name='type' options={documentTypeOptions} />
        </HookedFormField>
      )}
      <HookedFormField name='status' label='Status' required>
        <HookedSelect name='status' size='sm' options={statusOptions} optionVariant='tag' />
      </HookedFormField>
      <HookedFormField name='labelIds' label='Labels'>
        <HookedLabelChooser name='labelIds' type={LabelType.Template} />
      </HookedFormField>
    </FormStack>
  );
};
